/**
 * <Textarea />
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './Textarea.scss';

const DEFAULT_MAX_LENGTH = 500;
const DEFAULT_ROWS = 5;

export function textarea(props) {
  const {
    value,
    schema,
    onChange,
    options,
    placeholder,
  } = props;

  const {
    name,
  } = schema;

  const {
    maxlength,
  } = options;

  return (
    <Textarea 
      name={name}
      value={value}
      onChange={onChange}
      maxlength={maxlength}
      {...options}
    />
  );
}

class Textarea extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.props.onChange(e.target.value);
  }

  render() {
    const {
      name,
      value,
      onChange,
      rows = DEFAULT_ROWS,
      maxlength = DEFAULT_MAX_LENGTH,
    } = this.props

    return (
      <div className='textarea-wrapper form-input'>
        <textarea 
          style={{width: '100%'}} 
          value={value} 
          onChange={this.onChange} 
          className='form-control'
          rows={rows}
          maxLength={maxlength} 
        />
        <div className='text-count pull-right'>{(value || '').length} / {maxlength}</div>
      </div>
    ) 
  }
}

export default Textarea;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/Textarea/index.js